const locale = {
  TITLE: '403',
  MESSAGE: 'Sorry but you do not have permission to access this page',
};

export default locale;
